import axios from 'axios';

const URL_ENDPOINT = process.env.REACT_APP_URL_ENDPOINT
const URL_BOOKING_ENDPOINT = process.env.REACT_APP_URL_BOOKING_ENDPOINT
const URL_NEW = process.env.REACT_APP_URL_NEW
const URL_BELIEVE = process.env.REACT_APP_URL_BELIEVE
console.log(process.env)
console.log(URL_NEW,URL_BELIEVE)
export const axiosPublic = axios.create({
    baseURL: URL_ENDPOINT.trim(),
    headers: {
        'Content-Type': 'application/json',
    }
});

export const axiosPublicNew = axios.create({
    baseURL: URL_NEW.trim(),
    headers: {
        'Content-Type': 'application/json',
    }
});

export const axiosPublicBooking = axios.create({
    baseURL: URL_BOOKING_ENDPOINT.trim(),
    headers: {
        'Content-Type': 'application/json',
    }
});

export const axiosPublicBelieve = axios.create({
    baseURL: URL_BELIEVE.trim(),
    headers: {
        'Content-Type': 'application/json',
    }
});
